
const initailState = {
    arr:[],
    nextKey:'',
    secarr:[],
    secnextKey:'',

}
const PendingRides=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_PENDING_DATA':
            return{ 
                ...state,
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext,

            }
            case 'ADD_SECOND_PENDING_DATA':
                return{ 
                    ...state,
                    secarr: state.secarr.concat(action.payload),
                    secnextKey:action.keynext,
    
                }
                case 'CLEAN_SECOND_PENDING_DATA':
                return{ 
                    ...state,
                    secarr: [],
                    secnextKey:'',
    
                }
        default:
            return state;
    }
}

export default PendingRides